import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/helpers.js');
require('./js/fonts.js');
require('./js/framework.js');
require('./js/recommendations.js');
